export default "__VITE_ASSET__feb354d6__"